var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_1805)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    rx: 130,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130,
    fill: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.457 100.436C185.457 100.436 194.661 99.3176 195.493 108.08C196.325 116.842 193.388 123.576 187.928 126.488C187.928 126.488 186.757 127.06 184.079 127.528L185.457 100.462V100.436Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3276 100.436C81.3276 100.436 72.1236 99.3176 71.2916 108.08C70.4596 116.842 73.3976 123.576 78.8576 126.488C78.8576 126.488 80.0276 127.06 82.7056 127.528L81.3276 100.462V100.436Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 272.3C7.8 272.3 7.8 235.536 29.328 228.282C50.856 221.028 99.502 193.182 99.502 193.182H132.418V272.3H7.8Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.006 272.3C255.006 272.3 255.006 235.536 233.478 228.282C211.95 221.028 163.824 193.182 163.824 193.182H130.388V272.3H255.006Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.692 167.751L104.65 193.179H158.158L154.83 167.751H107.692Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.404 208.392C146.18 208.392 158.158 203.189 158.158 196.77C158.158 190.352 146.18 185.148 131.404 185.148C116.628 185.148 104.65 190.352 104.65 196.77C104.65 203.189 116.628 208.392 131.404 208.392Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.663 184.754C105.663 184.754 142.193 188.108 155.063 172.092V153.684L108.757 158.13L105.663 184.754Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.588 175.136C163.039 175.136 186.914 144.614 186.914 106.964C186.914 69.3134 163.039 38.7917 133.588 38.7917C104.137 38.7917 80.2623 69.3134 80.2623 106.964C80.2623 144.614 104.137 175.136 133.588 175.136Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.154 52.522C180.154 52.522 180.206 52.392 180.154 52.314C178.386 48.076 176.228 26.782 141.544 23.558C132.652 22.726 119.938 24.208 111.878 28.056C100.828 33.308 88.4782 36.324 77.5582 36.298C77.0902 36.298 76.9082 36.922 77.3242 37.156L85.8522 43.942C86.1902 44.124 86.1642 44.618 85.8002 44.774L75.0882 48.024C74.6982 48.18 74.6982 48.752 75.0882 48.882C76.8302 49.454 81.2502 51.404 85.2542 52.782C78.7022 64.378 80.2102 81.044 80.2102 101.064C80.2102 101.064 80.0022 121.812 86.9962 145.602C94.6402 171.602 111.41 182.756 135.044 182.834C160.212 182.938 173.342 161.358 176.852 153.688C182.208 141.936 186.81 120.096 186.836 106.966C186.836 106.966 196.508 73.79 180.102 52.522H180.154ZM158.782 148.852C153.582 151.504 156.208 137.698 145.86 137.126C142.402 136.918 130.65 136.112 120.77 136.944C113.256 137.594 111.436 144.354 111.098 147.786C110.942 149.268 110.422 149.944 109.018 149.424C105.898 148.28 99.2682 144.588 96.1482 141.156C92.9242 137.62 87.1002 128.078 86.5542 107.928L87.1262 79.146C87.1262 79.146 98.6962 69.448 100.698 62.558C100.698 62.558 152.386 70.826 167.362 62.558C167.362 62.558 173.628 74.544 180.466 78.158C182.572 79.25 182.208 92.926 182.026 102.364C181.844 103.638 181.688 105.094 181.61 106.81C180.232 133.772 163.93 146.226 158.756 148.878L158.782 148.852Z",
    fill: "#B54D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.783 112.422C160.52 112.422 161.929 109.977 161.929 106.962C161.929 103.946 160.52 101.502 158.783 101.502C157.045 101.502 155.637 103.946 155.637 106.962C155.637 109.977 157.045 112.422 158.783 112.422Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.592 111.304C113.329 111.304 114.738 108.86 114.738 105.844C114.738 102.829 113.329 100.384 111.592 100.384C109.854 100.384 108.446 102.829 108.446 105.844C108.446 108.86 109.854 111.304 111.592 111.304Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.254 131.508H132.288C130.078 131.508 128.128 130.65 127.088 129.22C126.334 128.206 126.126 127.01 126.49 125.84C127.608 122.252 129.064 108.862 129.064 108.732C129.142 108.004 129.766 107.51 130.494 107.588C131.196 107.666 131.716 108.316 131.638 109.018C131.586 109.59 130.13 122.772 128.96 126.62C128.856 127.01 128.908 127.348 129.168 127.712C129.714 128.44 130.936 128.934 132.288 128.934H137.254C137.982 128.934 138.554 129.506 138.554 130.234C138.554 130.962 137.982 131.534 137.254 131.534V131.508Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.537 120.977C166.549 120.977 170.611 120.046 170.611 118.897C170.611 117.748 166.549 116.817 161.537 116.817C156.526 116.817 152.463 117.748 152.463 118.897C152.463 120.046 156.526 120.977 161.537 120.977Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.575 120.977C113.586 120.977 117.649 120.046 117.649 118.897C117.649 117.748 113.586 116.817 108.575 116.817C103.563 116.817 99.5008 117.748 99.5008 118.897C99.5008 120.046 103.563 120.977 108.575 120.977Z",
    fill: "#FF9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.805 94.2738C161.147 91.7258 154.517 93.3378 150.487 93.8578C148.771 94.0658 148.407 91.9598 148.407 91.9598C148.069 90.5298 149.993 89.5418 151.345 89.2818C155.895 88.4498 161.719 88.0338 170.351 91.0238C172.015 91.5958 172.119 92.9998 172.119 92.9998C171.937 94.5598 170.949 94.5858 169.805 94.2478V94.2738Z",
    fill: "#B54D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.099 94.4333C108.705 91.7293 115.361 93.2373 119.391 93.6793C121.107 93.8613 121.445 91.7553 121.445 91.7553C121.757 90.3253 119.807 89.3633 118.455 89.1293C113.879 88.3753 108.055 88.0373 99.501 91.1833C97.837 91.7813 97.759 93.1853 97.759 93.1853C97.967 94.7453 98.955 94.7453 100.073 94.4073L100.099 94.4333Z",
    fill: "#B54D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.302 152.622C127.166 152.622 122.278 151.322 121.966 151.244C121.264 151.062 120.874 150.334 121.056 149.658C121.238 148.982 121.966 148.566 122.642 148.748C122.772 148.774 134.732 151.946 144.378 148.176C145.054 147.916 145.808 148.254 146.068 148.904C146.328 149.58 145.99 150.334 145.34 150.594C141.362 152.154 137.098 152.648 133.328 152.648L133.302 152.622Z",
    fill: "#9B3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.794 184.884L126.49 199.652L116.48 223.624L89.7 198.69L105.794 184.884Z",
    fill: "#FFA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.49 199.652L127.738 208.518L123.032 207.92L126.49 199.652Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.295 199.185L136.475 208.519L141.571 207.661L138.295 199.185Z",
    fill: "#F49037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.295 199.185L157.249 185.275L175.007 199.523L148.591 225.913L138.295 199.185Z",
    fill: "#FFA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.448 211.925H127.738V272.271H136.448V211.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.556 207.274L127.738 212.578C127.738 212.578 131.794 214.346 136.448 212.578L136.578 207.768L127.529 207.248L127.556 207.274Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.448 224.666H127.738V227.266H136.448V224.666Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.448 236.392H127.738V238.992H136.448V236.392Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.448 248.117H127.738V250.717H136.448V248.117Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.448 259.843H127.738V262.443H136.448V259.843Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.859 238.916C145.122 238.916 146.147 237.892 146.147 236.628C146.147 235.365 145.122 234.34 143.859 234.34C142.595 234.34 141.571 235.365 141.571 236.628C141.571 237.892 142.595 238.916 143.859 238.916Z",
    fill: "#FFA242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.859 264.444C145.122 264.444 146.147 263.42 146.147 262.156C146.147 260.892 145.122 259.868 143.859 259.868C142.595 259.868 141.571 260.892 141.571 262.156C141.571 263.42 142.595 264.444 143.859 264.444Z",
    fill: "#FFA242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_1805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    rx: 130,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.270c2ca8a87769a6c106c9802d6a446e.svg";
export { ForwardRef as ReactComponent };